/* eslint-disable react-hooks/exhaustive-deps, jsx-a11y/anchor-is-valid */
import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Button,
  Typography,
  Card,
  CardContent,
  Grid,
  useMediaQuery,
  useTheme,
  ToggleButton,
  ToggleButtonGroup,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { useTheme as useCustomTheme } from "../../style/theme";
import { useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CancelIcon from "@mui/icons-material/Cancel";
import starterImg from "../../assets/startericon.png";
import privateImg from "../../assets/privateicon.png";
import businessImg from "../../assets/businessicon.png";
import enterpriseImg from "../../assets/enterpriseicon.png";
import { FaCheck } from "react-icons/fa6";
import { RxCross1 } from "react-icons/rx";
import axios from "axios";
import { useUser } from "../../hooks/Authorize";
import PlanSkeleton from "./PlanSkeleton";

const SubscriptionPlansFiles = () => {
  const [plans, setPlans] = useState([]);
  const [plansforpermission, setplansforpermission] = useState([]);
  const [subscriptionUser, setSubscriptionUser] = useState(null);
  const [loadingPlans, setLoadingPlans] = useState(false);
  const theme = useTheme();
  const platformUser = useUser();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  // const plansEnterprise = [
  //   {
  //     id: "enterprise",
  //     name: "Enterprise",
  //     title: "For big companies",
  //     description:
  //       "Our most scalable and secure solution, customizable to your needs.",
  //     amount: "custom",
  //     icon: enterpriseImg,
  //     billingCycle: "monthly",

  //     permission: [
  //       {
  //         content: "Send and receive files/folders with customized size limit",
  //         isPermission: true,
  //       },
  //       { content: "Unlimited transfers", isPermission: true },
  //       { content: "Customized storage", isPermission: true },
  //       {
  //         content: "Add custom logos, backgrounds and promotional messages",
  //         isPermission: true,
  //       },
  //       { content: "Outlook Add-in", isPermission: true },
  //       { content: "Single sign-on (SSO)", isPermission: true },
  //       { content: "CNAME Record", isPermission: true },
  //       { content: "Carbon Footprint", isPermission: true },
  //     ],
  //   },
  // ];

  const getSubscription = async () => {
    // setLoadingPlans(true); // 👈 start loading
    try {
      const response = await axios.get(
        `/subscription/check-file/${platformUser?._id}`
      );
      const subscription = response.data.subscription;
      localStorage.setItem("subscription", JSON.stringify(subscription));
      setSubscriptionUser(subscription?.plan?.name);
      console.log(subscription, "gg");
    } catch (error) {
      console.error("Failed to fetch plans:", error);
    } finally {
      // setLoadingPlans(false); // 👈 stop loading
    }
  };

  const getPlans = async (interval) => {
    setLoadingPlans(true);
    try {
      const response = await axios.get(
        `/store/plan/files?interval=${interval}`
      );
      const fetchedPlans = response.data.data;
      setPlans(fetchedPlans);
      setplansforpermission(fetchedPlans);
      setLoadingPlans(false);
    } catch (error) {
      console.error("Failed to fetch plans:", error);
      setLoadingPlans(false);
    } finally {
      setLoadingPlans(false);
    }
  };

  // const featuresComparisonData = [
  //   {
  //     id: "Core",
  //     name: "Store Core features",
  //     detail: [
  //       {
  //         name: "Number of users",
  //         free: 1,
  //         Pro: 1,
  //         Teams: 10,
  //         Enterprise: "Customized",
  //       },
  //       {
  //         name: "Max. size per transfer",
  //         free: "2GB",
  //         Pro: "250GB",
  //         Teams: "500GB",
  //         Enterprise: "Customized",
  //       },
  //       {
  //         name: "Max. storage",
  //         free: "No storage   ",
  //         Pro: "1TB",
  //         Teams: "2TB",
  //         Enterprise: "Customized",
  //       },
  //       {
  //         name: "File availability",
  //         free: "Up to 7 days",
  //         Pro: "Up to 30 days",
  //         Teams: "Up to 30 days",
  //         Enterprise: "Up to 30 days",
  //       },
  //       {
  //         name: "Track views and downloads",
  //         free: <RxCross1 style={{ color: "85ADED" }} />,
  //         Pro: <FaCheck />,
  //         Teams: <FaCheck />,
  //         Enterprise: <FaCheck />,
  //       },
  //       {
  //         name: "256-bit AES and SSL/TLS encryption",
  //         free: <FaCheck />,
  //         Pro: <FaCheck />,
  //         Teams: <FaCheck />,
  //         Enterprise: <FaCheck />,
  //       },
  //     ],
  //   },
  //   {
  //     id: "Share",
  //     name: "Share features",
  //     detail: [
  //       {
  //         name: "Share by Email or Link",
  //         free: <FaCheck />,
  //         Pro: <FaCheck />,
  //         Teams: <FaCheck />,
  //         Enterprise: <FaCheck />,
  //       },
  //       {
  //         name: "Customization of the file transfers links",
  //         free: <FaCheck />,
  //         Pro: <FaCheck />,
  //         Teams: <FaCheck />,
  //         Enterprise: <FaCheck />,
  //       },
  //       {
  //         name: "File preview (images, videos & audio)",
  //         free: <FaCheck />,
  //         Pro: <FaCheck />,
  //         Teams: <FaCheck />,
  //         Enterprise: <FaCheck />,
  //       },
  //     ],
  //   },
  //   {
  //     id: "Tracking",
  //     name: "Tracking features",
  //     detail: [
  //       {
  //         name: "Transfer confirmation email",
  //         free: <FaCheck />,
  //         Pro: <FaCheck />,
  //         Teams: <FaCheck />,
  //         Enterprise: <FaCheck />,
  //       },
  //       {
  //         name: "Reception notification email",
  //         free: <RxCross1 style={{ color: "85ADED" }} />,
  //         Pro: <FaCheck />,
  //         Teams: <FaCheck />,
  //         Enterprise: <FaCheck />,
  //       },
  //       {
  //         name: "RDownload confirmation email",
  //         free: <FaCheck />,
  //         Pro: <FaCheck />,
  //         Teams: <FaCheck />,
  //         Enterprise: <FaCheck />,
  //       },
  //       {
  //         name: "Non-download notification email",
  //         free: <FaCheck />,
  //         Pro: <FaCheck />,
  //         Teams: <FaCheck />,
  //         Enterprise: <FaCheck />,
  //       },
  //       {
  //         name: "Transfer opening & download reporting",
  //         free: <RxCross1 style={{ color: "85ADED" }} />,
  //         Pro: <FaCheck />,
  //         Teams: <FaCheck />,
  //         Enterprise: <FaCheck />,
  //       },
  //     ],
  //   },
  //   {
  //     id: "Customization",
  //     name: "Customization tools",
  //     detail: [
  //       {
  //         name: "Custom sending, receiving and downloading page with your logo and background",
  //         free: <RxCross1 style={{ color: "85ADED" }} />,
  //         Pro: <FaCheck />,
  //         Teams: <FaCheck />,
  //         Enterprise: <FaCheck />,
  //       },
  //       {
  //         name: "Custom promotional pop-ins (your ads)",
  //         free: <RxCross1 style={{ color: "85ADED" }} />,
  //         Pro: <FaCheck />,
  //         Teams: <FaCheck />,
  //         Enterprise: <FaCheck />,
  //       },
  //       {
  //         name: "Custom subdomain (your-name.fromsmash.com)",
  //         free: <RxCross1 style={{ color: "85ADED" }} />,
  //         Pro: <FaCheck />,
  //         Teams: <FaCheck />,
  //         Enterprise: <FaCheck />,
  //       },
  //       {
  //         name: "Custom CNAME (your-name.your-domain.com)",
  //         free: <RxCross1 style={{ color: "85ADED" }} />,
  //         Pro: <RxCross1 style={{ color: "85ADED" }} />,
  //         Teams: <RxCross1 style={{ color: "85ADED" }} />,
  //         Enterprise: <FaCheck />,
  //       },
  //     ],
  //   },
  //   {
  //     id: "Powerful",
  //     name: "Powerful administrative tools",
  //     detail: [
  //       {
  //         name: "Sent and received files management",
  //         free: <RxCross1 style={{ color: "85ADED" }} />,
  //         Pro: <FaCheck />,
  //         Teams: <FaCheck />,
  //         Enterprise: <FaCheck />,
  //       },
  //       {
  //         name: "User management",
  //         free: <RxCross1 style={{ color: "85ADED" }} />,
  //         Pro: <RxCross1 style={{ color: "85ADED" }} />,
  //         Teams: <FaCheck />,
  //         Enterprise: <FaCheck />,
  //       },
  //       {
  //         name: "Roles/permission management",
  //         free: <RxCross1 style={{ color: "85ADED" }} />,
  //         Pro: <RxCross1 style={{ color: "85ADED" }} />,
  //         Teams: <FaCheck />,
  //         Enterprise: <FaCheck />,
  //       },
  //       {
  //         name: "Group management",
  //         free: <RxCross1 style={{ color: "85ADED" }} />,
  //         Pro: <RxCross1 style={{ color: "85ADED" }} />,
  //         Teams: <RxCross1 style={{ color: "85ADED" }} />,
  //         Enterprise: <FaCheck />,
  //       },
  //       {
  //         name: "Multi-team administration",
  //         free: <RxCross1 style={{ color: "85ADED" }} />,
  //         Pro: <RxCross1 style={{ color: "85ADED" }} />,
  //         Teams: <RxCross1 style={{ color: "85ADED" }} />,
  //         Enterprise: <FaCheck />,
  //       },
  //     ],
  //   },
  //   {
  //     id: "Security",
  //     name: "Security",
  //     detail: [
  //       {
  //         name: "Password protection for transfers",
  //         free: <FaCheck />,
  //         Pro: <FaCheck />,
  //         Teams: <FaCheck />,
  //         Enterprise: <FaCheck />,
  //       },
  //       {
  //         name: "Anti-virus protection for transfers",
  //         free: <FaCheck />,
  //         Pro: <FaCheck />,
  //         Teams: <FaCheck />,
  //         Enterprise: <FaCheck />,
  //       },
  //       {
  //         name: "256-bit AES and SSL/TLS encryption",
  //         free: <FaCheck />,
  //         Pro: <FaCheck />,
  //         Teams: <FaCheck />,
  //         Enterprise: <FaCheck />,
  //       },
  //       {
  //         name: "Independent third-party audits (annually)",
  //         free: <FaCheck />,
  //         Pro: <FaCheck />,
  //         Teams: <FaCheck />,
  //         Enterprise: <FaCheck />,
  //       },
  //       {
  //         name: "2Two-factor authentication",
  //         free: <RxCross1 style={{ color: "85ADED" }} />,
  //         Pro: <FaCheck />,
  //         Teams: <FaCheck />,
  //         Enterprise: <FaCheck />,
  //       },
  //       {
  //         name: "Single sign-on (SSO) integrations",
  //         free: <RxCross1 style={{ color: "85ADED" }} />,
  //         Pro: <RxCross1 style={{ color: "85ADED" }} />,
  //         Teams: <RxCross1 style={{ color: "85ADED" }} />,
  //         Enterprise: <FaCheck />,
  //       },
  //       {
  //         name: "Provisionning (SCIM)",
  //         free: <RxCross1 style={{ color: "85ADED" }} />,
  //         Pro: <RxCross1 style={{ color: "85ADED" }} />,
  //         Teams: <RxCross1 style={{ color: "85ADED" }} />,
  //         Enterprise: <FaCheck />,
  //       },
  //     ],
  //   },
  //   {
  //     id: "Support",
  //     name: "Support",
  //     detail: [
  //       {
  //         name: "Priority email support",
  //         free: <RxCross1 style={{ color: "85ADED" }} />,
  //         Pro: <FaCheck />,
  //         Teams: <FaCheck />,
  //         Enterprise: <FaCheck />,
  //       },
  //       {
  //         name: "TPhone support",
  //         free: <RxCross1 style={{ color: "85ADED" }} />,
  //         Pro: <RxCross1 style={{ color: "85ADED" }} />,
  //         Teams: <RxCross1 style={{ color: "85ADED" }} />,
  //         Enterprise: <FaCheck />,
  //       },
  //     ],
  //   },
  //   {
  //     id: "Plugins",
  //     name: "Plugins & Add-ins",
  //     detail: [
  //       {
  //         name: "Outlook",
  //         free: <RxCross1 style={{ color: "85ADED" }} />,
  //         Pro: <FaCheck />,
  //         Teams: <FaCheck />,
  //         Enterprise: <FaCheck />,
  //       },
  //     ],
  //   },
  //   {
  //     id: "Applications",
  //     name: "Applications",
  //     detail: [
  //       {
  //         name: "macOS, iOS and Android apps",
  //         free: <FaCheck />,
  //         Pro: <FaCheck />,
  //         Teams: <FaCheck />,
  //         Enterprise: <FaCheck />,
  //       },
  //     ],

  //   }, ];

  const [showFixedCards, setShowFixedCards] = useState(false);
  const plansRef = useRef(null);

  // const steps = ["Plan", "Add-Ons", "Pay", "Confirmation"];
  const { mode } = useCustomTheme();
  // const activeStep = 0; // Dynamically set the active step (currently step 1).
  const [expandAll, setExpandAll] = useState(true); // Toggle to expand/collapse all cards

  // const toggleExpandAll = () => {
  //   setExpandAll(!expandAll); // Toggle the state
  // };
  const [selectedPlan, setSelectedPlan] = useState("Monthly plans");

  const navigate = useNavigate();
  const handleChoosePlan = (plan) => {
    setExpandAll(true);
    navigate("/pay-step-files", {
      state: {
        plan,
        selectedPlan,
      },
    });
  };

  const handleBackClick = () => {
    navigate("/"); // Go back to the previous page in the history stack
  };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    getPlans("month");
    getSubscription();

    const handleScroll = () => {
      if (!plansRef.current) return;
      const plansTop = plansRef.current.getBoundingClientRect().top;
      setShowFixedCards(plansTop <= 0);
    };

    window.addEventListener("scroll", handleScroll);

    // ✅ Check once initially too
    handleScroll();

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handlePlanChange = (event, newPlan) => {
    if (newPlan !== null) {
      setSelectedPlan(newPlan);
      if (newPlan === "Monthly plans") {
        getPlans("month");
      } else if (newPlan === "Yearly Plans") {
        getPlans("year");
      }
    }
  };

  // Static "Free" Plan Data
  const freePlan = {
    name: "Free",
    permission: [
      {
        isShow: true,
        content: "Number of users",
        isUnlimited: false,
        noOfAllowed: 1,
        key: "no_of_users",
      },
      {
        isShow: true,
        content: "Max. size per transfer",
        isUnlimited: false,
        noOfAllowed: 2,
        storage_unit: "GB",
        key: "max_size",
      },
      {
        isShow: true,
        content: "Max. storage",
        isUnlimited: false,
        noOfAllowed: 5,
        storage_unit: "GB",
        key: "max_storage",
      },
      {
        isShow: true,
        content: "File availability",
        isUnlimited: false,
        noOfAllowed: 7,
        storage_unit: "days",
        key: "file_availability",
      },
      {
        isShow: true,
        content: "Track views and downloads",
        isUnlimited: false,
        isPermission: false,
        key: "views_and_downloads",
      },
      {
        isShow: true,
        content: "Share by Email or Link",
        isUnlimited: false,
        isPermission: true,
        key: "share_by_email",
      },
      {
        isShow: true,
        content: "Customization of the file transfers links",
        isUnlimited: false,
        isPermission: false,
        key: "Customization",
      },
      {
        isShow: true,
        content: "File preview (images, videos & audio)",
        isUnlimited: false,
        isPermission: false,
        key: "customization",
      },
      {
        isShow: true,
        content: "Transfer confirmation email",
        isUnlimited: false,
        isPermission: true,
        key: "confirmation_email",
      },
      {
        isShow: true,
        content: "Recipient notification email",
        isUnlimited: false,
        isPermission: false,
        key: "confirmation_email",
      },
      {
        isShow: true,
        content: "Download confirmation email",
        isUnlimited: false,
        isPermission: false,
        key: "confirmation_email",
      },
      {
        isShow: true,
        content: "Non-download notification email",
        isUnlimited: false,
        isPermission: false,
        key: "notification_email",
      },
      {
        isShow: true,
        content: "Transfer opening & download reporting",
        isUnlimited: false,
        isPermission: false,
        key: "download_reporting",
      },

      {
        isShow: true,
        content:
          "Custom sending, receiving and downloading page with your logo and background",
        isUnlimited: false,
        isPermission: false,
        key: "custom_sending",
      },
      {
        isShow: true,
        content: "Custom promotional pop-ins (your ads)",
        isUnlimited: false,
        isPermission: false,
        key: "custom_promotional",
      },
      {
        isShow: true,
        content: "Custom subdomain (your-name.fromsmash.com)",
        isUnlimited: false,
        isPermission: false,
        key: "custom_subdomain",
      },
      {
        isShow: true,
        content: "Custom CNAME (your-name.your-domain.com)",
        isUnlimited: false,
        isPermission: false,
        key: "custom_cNAME",
      },
      {
        isShow: true,
        content: "Sent and received files management",
        isUnlimited: false,
        isPermission: false,
        key: "files_management",
      },
      {
        isShow: true,
        content: "User management",
        isUnlimited: false,
        isPermission: false,
        key: "user_management",
      },
      {
        isShow: true,
        content: "Roles/permission management",
        isUnlimited: false,
        isPermission: false,
        key: "roles_management",
      },
      {
        isShow: true,
        content: "Group management",
        isUnlimited: false,
        isPermission: false,
        key: "group_management",
      },

      {
        isShow: true,
        content: "Multi-team administration",
        isUnlimited: false,
        isPermission: false,
        key: "administration",
      },
      {
        isShow: true,
        content: "Password protection for transfers",
        isUnlimited: false,
        isPermission: false,
        key: "password_protection",
      },
      {
        isShow: true,
        content: "Anti-virus protection for transfers",
        isUnlimited: false,
        isPermission: true,
        key: "virus_protection",
      },

      {
        isShow: true,
        content: "256-bit AES and SSL/TLS encryption",
        isUnlimited: false,
        isPermission: true,
        key: "aes_encryption",
      },

      {
        isShow: true,
        content: "Independent third-party audits (annually)",
        isUnlimited: false,
        isPermission: false,
        key: "third_party_audits",
      },
      {
        isShow: true,
        content: "Two-factor authentication",
        isUnlimited: false,
        isPermission: false,
        key: "authentication",
      },
      {
        isShow: true,
        content: "Single sign-on (SSO) integrations",
        isUnlimited: false,
        isPermission: false,
        key: "sso_integrations",
      },
      {
        isShow: true,
        content: "Provisionning (SCIM)",
        isUnlimited: false,
        isPermission: false,
        key: "Provisionning",
      },
      {
        isShow: true,
        content: "Priority email support",
        isUnlimited: false,
        isPermission: false,
        key: "email_support",
      },
      {
        isShow: true,
        content: "Phone support",
        isUnlimited: false,
        isPermission: false,
        key: "phone_support",
      },
      {
        isShow: true,
        content: "Outlook",
        isUnlimited: false,
        isPermission: false,
        key: "Outlook_add",
      },

      {
        isShow: true,
        content: "MacOS, iOS and Android apps",
        isUnlimited: false,
        isPermission: false,
        key: "Outlook_add",
      },
    ],
  };

  // API Plans Response Example (replace with actual fetched data)
  const apiPlans = plansforpermission;

  // Add the free plan manually at the beginning
  const allPlans = [freePlan, ...apiPlans];
  const planNames = plans.map((p) => p.name);

  // Step 1: Collect all features
  const allFeaturesMap = {};
  plans.forEach((plan) => {
    plan.permission.forEach((perm) => {
      if (perm.isShow) {
        if (!allFeaturesMap[perm.content]) {
          allFeaturesMap[perm.content] = {};
          // Har feature ke liye sab plans ko default "-" se initialize kar do
          planNames.forEach((name) => {
            allFeaturesMap[perm.content][name] = "-";
          });
        }

        let value;

        if (perm.noOfAllowed !== undefined) {
          value = `${perm.noOfAllowed === 0 ? "" : perm.noOfAllowed}${
            perm.storage_unit || ""
          }`;
        } else if (typeof perm.isPermission === "boolean") {
          value = perm.isPermission;
        } else {
          value = "-";
        }

        allFeaturesMap[perm.content][plan.name] = value;
      }
    });
  });

  // Step 2: Convert to array for table rows
  const tableData = Object.entries(allFeaturesMap).map(([feature, values]) => ({
    name: feature,
    ...values,
  }));

  console.log(tableData, "jj");

  return (
    <>
      <Box>
        <Button
          onClick={handleBackClick}
          sx={{
            color: mode === "light" ? "#26272C" : "#FFFFFF",
            // padding: "0.5rem 1rem",
            fontSize: "15px",
            display: "flex",
            alignItems: "center",
            borderRadius: "5px",
          }}
        >
          <ArrowBackIcon sx={{ marginRight: "0.5rem" }} />
        </Button>
      </Box>

      <Box
        sx={{
          textAlign: "center",
          py: 6,
          px: 2,
          // background: "linear-gradient(to bottom, white, #f9f9f9)",
        }}
      >
        <Typography
          variant="h2"
          component="h1"
          sx={{
            fontWeight: "bold",
            mb: 2,
            fontFamily: "Nunito",
            color: mode === "light" ? "#26272C" : "#FFFFFF",
          }}
        >
          Plans & pricing
        </Typography>
        <Typography
          variant="body1"
          sx={{ color: "text.secondary", mb: 4, fontSize: "20px" }}
        >
          For a limited time, save up to 52% on Pro and Team plans.
        </Typography>
      </Box>

      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          mb: 2,
        }}
      >
        <ToggleButtonGroup
          value={selectedPlan}
          onChange={handlePlanChange}
          exclusive
          sx={{
            border: "1px solid #fff",
            borderRadius: "30px",
            overflow: "hidden",
            backgroundColor: "#85aded",
          }}
        >
          {["Monthly plans", "Yearly Plans"].map((plan) => (
            <ToggleButton
              key={plan}
              value={plan}
              sx={{
                px: 4,
                py: 1.5,
                backgroundColor: selectedPlan === plan ? "#003399" : "#85aded",
                fontSize: "14px",
                fontWeight: selectedPlan === plan ? "bold" : "normal",
                border: "none",
                color: "#fff",
                textTransform: "none",
                "&.Mui-selected": {
                  backgroundColor: "#003399",
                  color: "#fff",
                  fontWeight: "bold",
                },
                "&:hover": {
                  backgroundColor: "#003399",
                },
              }}
            >
              {plan}
            </ToggleButton>
          ))}
        </ToggleButtonGroup>
      </Box>

      {/* Plans */}
      {loadingPlans ? (
        <PlanSkeleton isMobile={isMobile} />
      ) : plans?.length > 0 ? (
        <Grid container spacing={0} sx={{ p: 4, justifyContent: "center" }}>
          {plans?.map((plan) => {
            const isPopular = plan.name === "Pro" ? true : false;
            return (
              <Grid
                item
                xs={12}
                sm={6}
                md={3}
                key={plan.id}
                sx={{
                  px: 1, // Remove all padding
                  background: isPopular
                    ? "linear-gradient(42deg, rgba(67,183,230,1) 13%, rgba(0,128,255,1) 40%)"
                    : mode === "light"
                    ? ""
                    : "#141414",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "column",
                  borderRadius: 8,
                  paddingTop: isPopular ? "0px" : "14px",
                }}
              >
                <Typography
                  sx={{
                    fontSize: isMobile ? "0.8rem" : "1rem",
                    fontWeight: 500,
                    color: "#ffff",
                  }}
                >
                  {isPopular ? "Most popular" : ""}
                </Typography>
                <Card
                  sx={{
                    height: expandAll ? "95%" : 350,
                    // minWidth:"265px",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    background: mode === "light" ? "#ffff" : "#141414",
                    border: isPopular
                      ? "1px solid linear-gradient(42deg, rgba(67,183,230,1) 13%, rgba(0,128,255,1) 40%)"
                      : mode === "light"
                      ? "1px solid #ffff"
                      : "1px solid #2e2e2e",
                    color: mode === "light" ? "black" : "#fff",
                    borderRadius: 6,
                    // border: isPopular ? "none" : "1px solid #0080FF",
                    position: "relative",
                    paddingY: isMobile ? 2 : 4,
                    paddingX: isMobile ? 2 : 0,
                    transition: "height 0.3s ease",
                  }}
                >
                  {isPopular && (
                    <Box
                      sx={{
                        position: "absolute",
                        top: 10,
                        right: 10,
                        background: "#3ea2fb",
                        color: "#fff",
                        fontSize: "0.7rem",
                        fontWeight: "bold",
                        px: 1,
                        py: 0.5,
                        borderRadius: "4px",
                      }}
                    >
                      Popular
                    </Box>
                  )}

                  <CardContent
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      height: "100%",
                    }}
                  >
                    {/* Header */}
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 2,
                        mb: 2,
                      }}
                    >
                      <Box
                        sx={{
                          width: isMobile ? 36 : 48,
                          height: isMobile ? 36 : 48,
                          borderRadius: 2,
                          backgroundColor:
                            mode === "light" ? "#f3f3f3" : "#1e1e1e",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <img
                          src={
                            plan?.name === "Free"
                              ? starterImg
                              : plan?.name === "Pro"
                              ? privateImg
                              : plan?.name === "Team"
                              ? businessImg
                              : enterpriseImg
                          }
                          alt="icon"
                          width="30"
                          height="30"
                        />
                      </Box>
                      <Box>
                        <Typography
                          sx={{
                            fontSize: isMobile ? "0.8rem" : "0.9rem",
                            fontWeight: 400,
                            color: mode === "light" ? "#585A5A" : "#cfcfcf",
                          }}
                        >
                          {plan.title}
                        </Typography>
                        <Typography
                          variant="h6"
                          sx={{
                            fontSize: isMobile ? "1rem" : "1.25rem",
                            fontWeight: "bold",
                            color: mode === "light" ? "#26272C" : "#fff",
                          }}
                        >
                          {plan.name}
                        </Typography>
                      </Box>
                    </Box>

                    {/* Description */}
                    <Typography
                      sx={{
                        fontSize: isMobile ? "0.9rem" : "0.87rem",
                        color: mode === "light" ? "#585A5A" : "#D9DBE9",
                        minHeight: isMobile ? "150px" : "130px",
                        overflow: "visible",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {plan.description}
                    </Typography>

                    {/* Price + Button */}
                    <Box>
                      <Typography
                        sx={{
                          fontSize: isMobile ? "1.45rem" : "1.9rem",
                          fontWeight: "bold",
                          color: "#38bdf8",
                          mb: 2,
                          height: isMobile ? "50px" : "70px",
                          pl: isMobile ? 0 : 2,
                        }}
                      >
                        $
                        {plan.amount === 0
                          ? "Free"
                          : plan.interval === "month"
                          ? plan.amount
                          : (plan.amount / 12).toFixed(2)}
                        {plan.amount !== "0" && plan.amount !== "custom" && (
                          <p
                            style={{
                              fontSize: isMobile ? "0.7rem" : "0.9rem",
                              marginLeft: 4,
                            }}
                          >
                            /monthly
                          </p>
                        )}
                      </Typography>
                    </Box>

                    <Box
                      sx={{
                        marginBottom: "20px",
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <Button
                        onClick={() => handleChoosePlan(plan)}
                        fullWidth
                        variant="contained"
                        disabled={plan.name === subscriptionUser}
                        sx={{
                          fontWeight: 600,
                          background: isPopular
                            ? "linear-gradient(42deg, rgba(67,183,230,1) 13%, rgba(0,128,255,1) 40%)"
                            : "#fff",
                          color: isPopular ? "#fff" : "#2563EB",
                          fontSize: isMobile ? "1rem" : "0.975rem",
                          textTransform: "none",
                          "&:hover": {
                            background: isPopular
                              ? "linear-gradient(42deg , rgba(67,183,230,0.9) 13%, rgba(0,128,255,0.9) 40%)"
                              : "#e2e8f0",
                          },
                          width: "90%",
                          borderRadius: "20px",
                          height: isMobile ? "50px" : "60px",
                        }}
                      >
                        {plan.name === subscriptionUser ? (
                          <>Subscribed</>
                        ) : (
                          <>
                            {plan.amount === "Free"
                              ? "Start Now"
                              : plan.amount === "custom"
                              ? "custom"
                              : "Subscribe"}
                          </>
                        )}
                      </Button>
                    </Box>

                    {/* Features (expandable) */}

                    <Box
                      sx={{
                        mb: 2,
                        pr: 1,

                        height: "100%",
                        overflow: "visible",
                        textOverflow: "ellipsis",
                      }}
                    >
                      <Typography
                        sx={{
                          fontWeight: "semibold",
                          fontSize: isMobile ? "0.8rem" : "1rem",
                          color: mode === "light" ? "#26272C" : "#fff",
                          borderBottom: "1px solid #919294",
                          height: "40px",
                          width: "100%",
                          textAlign: "center",
                          mb: 3,
                        }}
                      >
                        <p className="text-sm text-muted-foreground">
                          {plan.name === "Free"
                            ? "With no registration"
                            : plan.name === "Pro"
                            ? "1 user"
                            : plan.name === "Team"
                            ? "10 users included"
                            : plan.name === "Enterprise"
                            ? "+10 users"
                            : ""}
                        </p>
                      </Typography>
                      {plan?.permission?.map((feature, index) => {
                        return (
                          <Box
                            key={index}
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              mb: 1,
                              minHeight: isMobile ? 30 : 36,
                            }}
                          >
                            {feature.isPermission ? (
                              <CheckCircleIcon
                                sx={{
                                  fontSize: isMobile ? 16 : 15,
                                  color: "#38bdf8",
                                  mr: 1,
                                }}
                              />
                            ) : (
                              <CancelIcon
                                sx={{
                                  fontSize: isMobile ? 16 : 15,
                                  color: "#38bdf8",
                                  mr: 1,
                                }}
                              />
                            )}
                            <Typography
                              sx={{
                                fontSize: isMobile ? "0.75rem" : "0.9rem",
                                color: mode === "light" ? "#585A5A" : "#e5e5e5",
                              }}
                            >
                              {feature.content}
                            </Typography>
                          </Box>
                        );
                      })}
                    </Box>
                  </CardContent>
                </Card>
              </Grid>
            );
          })}
        </Grid>
      ) : (
        <Box
          width="100%"
          display="flex"
          justifyContent="center"
          alignItems="center"
          height="300px"
        >
          <Typography variant="h5" sx={{ color: "#A5A5A5" }}>
            No plans found for Clikkle Files
          </Typography>
        </Box>
      )}

      {/*fixed card */}
      {showFixedCards && expandAll && plans?.length > 0 && (
        <Box
          mt={4}
          sx={{
            position: "fixed",
            top: -35,
            width: "100%",
            overflowX: "auto",
            pr: isMobile ? "24px" : "21px",
            pl: isMobile ? "16px" : "16px",
            zIndex: 1300,
            // backgroundColor:'red',
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Box
            sx={{
              // border: "1px solid #0080FF", // deep blue like image
              // borderRadius: "12px",
              overflow: "hidden",
              width: isMobile ? "100%" : "90%",
            }}
          >
            <table
              // ref={plansRef}
              style={{
                width: "100%",
                borderCollapse: "collapse",
                tableLayout: "fixed",
                border: "1px solid #0080FF",
                // position: "fixed",
                // top: 0,
                // left: 0,
                // right: 0,
                // zIndex: 1300,
              }}
            >
              <thead>
                <tr
                  style={{
                    backgroundColor: mode === "light" ? "#f9f9f9" : "#121212",
                  }}
                >
                  <th
                    style={{
                      textAlign: "center",
                      padding: "14px 16px",
                      fontWeight: 600,
                      fontSize: "14px",
                      color: "#60A5FA",
                      width: "17.5%",
                      borderRight: "1px solid #0080FF",
                      display: isMobile ? "none" : "",
                    }}
                  >
                    <Button
                      sx={{
                        border: "1px solid #0080FF",
                        borderRadius: 6,
                        px: 5,
                      }}
                    >
                      All Features
                    </Button>
                  </th>
                  {plans?.map((plan, idx) => {
                    const isPopular = plan.name === "Pro" ? true : false;
                    return (
                      <th
                        key={plan.id || plan.name}
                        style={{
                          textAlign: "center",
                          padding: isMobile ? "2px 3px" : "14px 8px",
                          fontWeight: 600,
                          fontSize: "14px",
                          color: "#60A5FA",
                          width: isMobile ? "83.5%" : `${82.5 / plans.length}%`, // 👈 fixed width on mobile
                          borderRight:
                            idx === plans.length - 1
                              ? "none"
                              : "1px solid #0080FF",
                          background: isPopular
                            ? "linear-gradient(42deg, rgba(67,183,230,1) 13%, rgba(0,128,255,1) 40%)"
                            : mode === "light"
                            ? "#ffff"
                            : "#121212",
                        }}
                      >
                        <Card
                          key={plan.id}
                          sx={{
                            width: "100%",
                            flexShrink: 0,
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "space-between",
                            // background: isPopular
                            //   ? "linear-gradient(42deg, rgba(67,183,230,1) 13%, rgba(0,128,255,1) 40%)"
                            //   : mode === "light"
                            //   ? "#ffff"
                            //   : "#121212",
                            boxShadow: "none",
                            color: "#fff",
                            borderRadius: 3,
                            // border: isPopular ? "none" : "1px solid #0080FF",
                            position: "relative",
                            p: isMobile ? 1 : 3,
                            transition: "height 0.3s ease",
                          }}
                        >
                          {isPopular && (
                            <Box
                              sx={{
                                position: "absolute",
                                top: 10,
                                right: 10,
                                background: "#3ea2fb",
                                color: "#fff",
                                fontSize: isMobile ? "0.4rem" : "0.7rem",
                                fontWeight: "bold",
                                px: isMobile ? 0.5 : 1.5,
                                py: isMobile ? 0.1 : 0.5,
                                borderRadius: "4px",
                              }}
                            >
                              Popular
                            </Box>
                          )}

                          <CardContent sx={{ height: "100%" }}>
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",

                                flexDirection: isMobile ? "column" : "",
                                gap: isMobile ? 0 : 2,
                                mb: isMobile ? 0 : 2,
                              }}
                            >
                              <Box
                                sx={{
                                  width: isMobile ? 32 : 65,
                                  height: isMobile ? 32 : 55,
                                  borderRadius: 2,
                                  backgroundColor:
                                    mode === "light" ? "#f3f3f3" : "#1e1e1e",
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                }}
                              >
                                <img
                                  src={
                                    plan?.name === "Free"
                                      ? starterImg
                                      : plan?.name === "Pro"
                                      ? privateImg
                                      : plan?.name === "Team"
                                      ? businessImg
                                      : enterpriseImg
                                  }
                                  alt="icon"
                                  width={isMobile ? "20" : "30"}
                                  height={isMobile ? "20" : "30"}
                                />
                              </Box>
                              <Box>
                                <Typography
                                  sx={{
                                    fontSize: isMobile ? "0.7rem" : "0.6rem",
                                    fontWeight: 400,
                                    color:
                                      mode === "light" ? "#585A5A" : "#cfcfcf",
                                    textAlign: isMobile ? "center" : "left",
                                  }}
                                >
                                  {plan.title}
                                </Typography>
                                <Typography
                                  variant="h6"
                                  sx={{
                                    fontSize: isMobile ? "0.6rem" : "0.9rem",
                                    fontWeight: "bold",
                                    color:
                                      mode === "light" ? "#26272C" : "#fff",
                                  }}
                                >
                                  {plan.name}
                                </Typography>
                              </Box>
                            </Box>

                            <Typography
                              sx={{
                                fontSize: isMobile ? "0.8rem" : "1.6rem",
                                fontWeight: "bold",
                                color: "#38bdf8",
                                mb: isMobile ? 0 : 2,
                              }}
                            >
                              $
                              {plan.interval === "month"
                                ? plan.amount
                                : plan.amount === 0
                                ? "Free"
                                : (plan.amount / 12).toFixed(2)}
                              {plan.amount !== "Free" &&
                                plan.amount !== "custom" && (
                                  <span
                                    style={{
                                      fontSize: isMobile ? "0.5rem" : "0.7rem",
                                      marginLeft: 4,
                                    }}
                                  >
                                    /monthly
                                  </span>
                                )}
                            </Typography>
                          </CardContent>
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              height: "0%",
                              mb: 1,
                            }}
                          >
                            <Button
                              onClick={() => handleChoosePlan(plan)}
                              fullWidth
                              variant="contained"
                              disabled={plan?.name === subscriptionUser}
                              sx={{
                                fontWeight: 600,
                                background: isPopular
                                  ? "linear-gradient(42deg, rgba(67,183,230,1) 13%, rgba(0,128,255,1) 40%)"
                                  : "#fff",
                                color: isPopular ? "#fff" : "#2563EB",
                                fontSize: isMobile ? "0.4rem" : "0.775rem",
                                textTransform: "none",
                                "&:hover": {
                                  background: isPopular
                                    ? "linear-gradient(42deg , rgba(67,183,230,0.9) 13%, rgba(0,128,255,0.9) 40%)"
                                    : "#e2e8f0",
                                },
                                width: "90%",
                                borderRadius: "20px",
                                height: isMobile ? "50px" : "60px",
                              }}
                            >
                              {plan.name === subscriptionUser ? (
                                <>Subscribed</>
                              ) : (
                                <>
                                  {plan.amount === "Free"
                                    ? "Start Now"
                                    : plan.amount === "custom"
                                    ? "custom"
                                    : "Subscribe"}
                                </>
                              )}
                            </Button>
                          </Box>
                        </Card>
                      </th>
                    );
                  })}
                </tr>
              </thead>
            </table>
          </Box>
        </Box>
      )}

      {isMobile
        ? expandAll && plans?.length > 0 && (
            <Box mt={4} sx={{ p: 2, width: "100%" }}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Box
                    sx={{
                      border: "1px solid #0080FF",
                      borderRadius: "12px",
                      backgroundColor: mode === "light" ? "#fff" : "#1e1e1e",
                      marginBottom: "55px",
                    }}
                  >
                    {/* Loop over each feature */}
                    {tableData.map((feature, idx) => (
                      <Box key={idx} sx={{ mb: 2 }}>
                        {/* Feature Name */}
                        <Typography
                          sx={{
                            fontSize: "12px",
                            fontWeight: 600,
                            color: mode === "light" ? "#26272C" : "#FFFFFF",
                            paddingX: "20px",
                            paddingY: "8px",
                          }}
                        >
                          {feature.name}
                        </Typography>

                        {/* Feature Values Row */}
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderRadius: "8px",
                            overflow: "hidden",
                          }}
                        >
                          {planNames.map((plan) => (
                            <Box
                              key={plan}
                              sx={{
                                flex: 1,
                                textAlign: "center",
                                padding: "12px",
                                backgroundColor:
                                  plan === "Pro" ? "#0080FF" : "transparent",
                                color:
                                  plan === "Pro"
                                    ? "#fff"
                                    : mode === "light"
                                    ? "#000"
                                    : "#fff",
                                fontWeight: 500,
                                fontSize: "10px",
                                width: `${100 / planNames.length}%`,
                              }}
                            >
                              {feature[plan] === true ? (
                                <FaCheck />
                              ) : feature[plan] === false ? (
                                <RxCross1 style={{ color: "#85ADED" }} />
                              ) : (
                                feature[plan] || "-"
                              )}
                            </Box>
                          ))}
                        </Box>
                      </Box>
                    ))}
                  </Box>
                </Grid>
              </Grid>
            </Box>
          )
        : expandAll && plans?.length > 0 && (
            <Box
              mt={4}
              sx={{
                overflowX: "auto",
                p: 2,
                width: "100%",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Box
                sx={{
                  border: "1px solid #0080FF",
                  borderRadius: "12px",
                  overflow: "hidden",
                  width: "90%",
                }}
              >
                <table
                  ref={plansRef}
                  style={{
                    width: "100%",
                    borderCollapse: "collapse",
                    tableLayout: "fixed",
                  }}
                >
                  <tbody>
                    {tableData.map((feature, idx) => (
                      <tr key={idx} style={{ borderBottom: "1px solid #ccc" }}>
                        <td
                          style={{
                            padding: "10px 16px",
                            fontSize: "14px",
                            color: mode === "light" ? "#111" : "#FFFF",
                            textAlign: "left",
                            width: "17.5%",
                          }}
                        >
                          {feature.name}
                        </td>
                        {planNames.map((plan) => (
                          <td
                            key={plan}
                            style={{
                              textAlign: "center",
                              backgroundColor: plan === "Pro" ? "#0080FF" : "transparent",
                              color: plan === "Pro" ? "#FFFF" : (mode === "light" ? "#111" : "#FFFF"),
                              width: `${82.5 / planNames.length}%`,
                            }}
                          >
                            {feature[plan] === true ? (
                              <FaCheck />
                            ) : feature[plan] === false ? (
                              <RxCross1 style={{ color: "#85ADED" }} />
                            ) : (
                              feature[plan] || "-"
                            )}
                          </td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </Box>
            </Box>
          )}
    </>
  );
};

export default SubscriptionPlansFiles;
